'use strict';

var debug;
var assert;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:setComplexTitle');
    assert = require('assert');
}

var _invoke = require('../invoke');

/**
 * 设置复杂标题
 *
 * 根据传入的 `type` 判断使用那种展示形式。
 * 如果当前版本不支持 `type`，会回退到普通形式，只展示 `title`。
 *
 * 目前只支持上下双栏的主副标题 `type='two-row'`
 *
 * 支持版本
 * + iHotel/5.9.2+
 *
 * @memberof webview
 * @static
 * @name setComplexTitle
 * @param {Object} opts 标题设置
 * @return {Undefined}
 * @example
 *  hbnb.webview.setComplexTitle({
 *      type: 'two-row',
 *      title: 'title',
 *      subTitle: 'subTitle'
 *  });
 */
module.exports = function(opts) {
    if (process.env.NODE_ENV !== 'production') {
        debug('opts is %j', opts);
        assert(opts.title);
    }

    _invoke('webview', 'set_complex_title', opts);
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/set-complex-title.js
// module id = 665
// module chunks = 0